export const GET_USER = "GET_USER";
export const USER_STATUS = "USER_STATUS";
export const GET_INFO = "GET_INFO";
export const GET_DEVICE = "GET_DEVICE";
export const GET_STATUS = "GET_STATUS";
export const GET_SUBJECT = "GET_SUBJECT";
export const APIURL = "https://south.wdsmanager.com";
